module.exports = __webpack_public_path__ + "static/media/admin-signin-righ-ellipse.b19cad91.png";